import {
  Table,
  TableHeader,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from "V2.0/common/table";

import { Button } from "V2.0/common/button";
import { Badge } from "V2.0/common/badge";
import { PencilIcon, TrashIcon } from "@heroicons/react/24/outline";

export default function TransferAgentsTable(props) {
  const { agents, onAgentDelete, onAgentEdit, showActions } = props;

  if (agents.length === 0) {
    return (
      <div className="flex items-center justify-center h-full min-h-96">
        <p className="text-lg font-medium">No agents</p>
      </div>
    );
  }

  return (
    <Table>
      <TableHead>
        <TableHeader>Agent</TableHeader>
        <TableHeader>Phone Number</TableHeader>
        <TableHeader>Email</TableHeader>
        {showActions && <TableHeader>Actions</TableHeader>}
      </TableHead>
      <TableBody>
        {agents.map((agent, idx) => {
          return (
            <TableRow key={idx}>
              <TableCell>
                <div className="flex gap-x-4 items-center">
                  <p className="text-sm font-medium">{agent.name}</p>
                  {agent?.slotTag && (
                    <Badge color="green">{agent.slotTag}</Badge>
                  )}
                </div>
              </TableCell>
              <TableCell>{agent.phoneNumber}</TableCell>
              <TableCell>{agent.email ?? <Badge>n/a</Badge>}</TableCell>
              {showActions && (
                <TableCell>
                  <div className="flex gap-x-2">
                    <Button
                      outline
                      onClick={() => onAgentEdit(agent, idx)}
                    >
                      <PencilIcon />
                    </Button>
                    <Button
                      outline
                      onClick={() => onAgentDelete(agent, idx)}
                    >
                      <TrashIcon />
                    </Button>
                  </div>
                </TableCell>
              )}
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
}
